import { render } from "./Shop.vue?vue&type=template&id=2891cb10&scoped=true&ts=true"
import script from "./Shop.vue?vue&type=script&lang=ts"
export * from "./Shop.vue?vue&type=script&lang=ts"

import "./Shop.vue?vue&type=style&index=0&id=2891cb10&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2891cb10"]])

export default __exports__